import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Auth';

export const login = async (formData) => {
    const result = await request.post(`${baseUrl}/ParentLogin`, formData);

    return result;
}

export const change2FAMethod = async (data) => {
    const result = await request.post(`${baseUrl}/Change2FAMethod`, data);

    return result;
}

export const scanCodeForAuthenticatorAgain = async (data) => {
    const result = await request.post(`${baseUrl}/ScanCodeForAuthenticatorAgain`, data);

    return result;
}

export const verify2FALogin = async (data) => {
    const result = await request.post(`${baseUrl}/Verify2FALogin`, data);

    return result;
}

export const verifyEmailLogin = async (data) => {
    const result = await request.post(`${baseUrl}/VerifyEmailLogin`, data);

    return result;
}

export const verifyFact = async (data) => {
    const result = await request.post(`${baseUrl}/VerifyFact`, data);

    return result;
}

export const resendEmailCode = async (egn) => {
    const result = await request.get(`${baseUrl}/ResendEmailCode?egn=${egn}`);

    return result;
}

export const confirmEmail = async (token, email, cn) => {
    const result = await request.get(`${baseUrl}/ConfirmEmail?token=${token}&email=${email}&cn=${cn}`);

    return result;
}

export const logout = async () => {
    const result = await request.get(`${baseUrl}/Logout`);

    return result;
}



